"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnfoldIsEnabledContext = exports.Leaf = exports.CapitalizeFirstLetter = exports.InlineMecanismName = exports.InfixMecanism = exports.Mecanism = exports.NodeValuePointer = exports.ConstantNode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const publicodes_1 = require("publicodes");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const contexts_1 = require("../contexts");
const mecanisms_json_1 = __importDefault(require("../data/mecanisms.json"));
const Explanation_1 = __importDefault(require("../Explanation"));
const Markdown_1 = require("../Markdown");
const Overlay_1 = __importDefault(require("../Overlay"));
const RuleLink_1 = require("../RuleLink");
const colors_1 = __importDefault(require("./colors"));
function ConstantNode({ nodeValue, type, fullPrecision, unit }) {
    if (nodeValue === null) {
        return null;
    }
    else if (type === 'objet') {
        return (jsx_runtime_1.jsx("code", { children: jsx_runtime_1.jsx("pre", { children: JSON.stringify(nodeValue, null, 2) }, void 0) }, void 0));
    }
    else if (fullPrecision) {
        return (jsx_runtime_1.jsx("span", Object.assign({ className: type }, { children: publicodes_1.formatValue({ nodeValue, unit }, {
                precision: 5,
            }) }), void 0));
    }
    else {
        return jsx_runtime_1.jsx("span", Object.assign({ className: "value" }, { children: nodeValue }), void 0);
    }
}
exports.ConstantNode = ConstantNode;
const NodeValuePointer = ({ data, unit }) => {
    var _a;
    const engine = react_1.useContext(contexts_1.EngineContext);
    return (jsx_runtime_1.jsx("small", Object.assign({ className: "nodeValue", style: {
            background: 'white',
            borderBottom: '0 !important',
            margin: '0 0.2rem',
            padding: '0 0.2rem',
            textDecoration: 'none !important',
            boxShadow: '0px 1px 2px 1px #d9d9d9, 0 0 0 1px #d9d9d9',
            lineHeight: '1.6em',
            borderRadius: '0.2rem',
        } }, { children: publicodes_1.formatValue(publicodes_1.simplifyNodeUnit({ nodeValue: data, unit }), {
            formatUnit: (_a = engine === null || engine === void 0 ? void 0 : engine.getOptions()) === null || _a === void 0 ? void 0 : _a.formatUnit,
        }) }), void 0));
};
exports.NodeValuePointer = NodeValuePointer;
function Mecanism({ name, value, children, unit, displayName = true, }) {
    return (jsx_runtime_1.jsxs(StyledMecanism, Object.assign({ name: name }, { children: [displayName && jsx_runtime_1.jsx(MecanismName, Object.assign({ name: name }, { children: name }), void 0),
            jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [children, value != null && (jsx_runtime_1.jsxs("div", Object.assign({ style: {
                            textAlign: 'right',
                            marginTop: '0.4rem',
                            fontWeight: 'bold',
                        } }, { children: [jsx_runtime_1.jsx("small", { children: " =\u00A0" }, void 0),
                            jsx_runtime_1.jsx(exports.NodeValuePointer, { data: value, unit: unit }, void 0)] }), void 0))] }, void 0)] }), void 0));
}
exports.Mecanism = Mecanism;
const InfixMecanism = ({ value, prefixed, children, dimValue, }) => {
    return (jsx_runtime_1.jsxs(StyledInfixMecanism, Object.assign({ className: "infix-mecanism" }, { children: [prefixed && children, jsx_runtime_1.jsxs("div", Object.assign({ className: "value", style: {
                    position: 'relative',
                } }, { children: [dimValue && jsx_runtime_1.jsx(DimOverlay, {}, void 0),
                    jsx_runtime_1.jsx(Explanation_1.default, { node: value }, void 0)] }), void 0), !prefixed && children] }), void 0));
};
exports.InfixMecanism = InfixMecanism;
const DimOverlay = styled_components_1.default.div `
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	background-color: white;
	left: 0;
	opacity: 0.5;
	pointer-events: none;
	z-index: 1;
`;
const StyledInfixMecanism = styled_components_1.default.div `
	.value > .infix-mecanism {
		border: none;
		padding: 0;
	}
	.value > :not(.infix-mecanism):not(${DimOverlay}) {
		margin-bottom: 1rem;
	}
`;
const InlineMecanismName = ({ name }) => {
    return (jsx_runtime_1.jsx(MecanismName, Object.assign({ inline: true, name: name }, { children: name }), void 0));
};
exports.InlineMecanismName = InlineMecanismName;
const MecanismName = ({ name, inline = false, children, }) => {
    const [showExplanation, setShowExplanation] = react_1.useState(false);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(StyledMecanismName, Object.assign({ name: name, inline: inline, onClick: () => setShowExplanation(true) }, { children: children }), void 0),
            showExplanation && (jsx_runtime_1.jsx(Overlay_1.default, Object.assign({ onClose: () => setShowExplanation(false) }, { children: jsx_runtime_1.jsx(RuleExplanation, Object.assign({ name: name }, mecanisms_json_1.default[name]), void 0) }), void 0))] }, void 0));
};
function RuleExplanation({ name, description, exemples, }) {
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [!!name && (jsx_runtime_1.jsx("h2", Object.assign({ id: name }, { children: jsx_runtime_1.jsx("pre", { children: name }, void 0) }), void 0)),
            jsx_runtime_1.jsx(Markdown_1.Markdown, { source: description }, void 0),
            exemples && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [Object.entries(exemples).map(([name, exemple]) => (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx("h3", { children: name === 'base' ? 'Exemple' : publicodes_1.capitalise0(name) }, void 0),
                            jsx_runtime_1.jsx(Markdown_1.Markdown, { source: `\`\`\`yaml\n${exemple}\n\`\`\`` }, void 0)] }, name))), ' '] }, void 0))] }, void 0));
}
exports.default = RuleExplanation;
const StyledMecanism = styled_components_1.default.div `
	border: 1px solid;
	max-width: 100%;
	border-radius: 3px;
	padding: 1rem;
	position: relative;
	flex: 1;
	flex-direction: column;
	border-color: ${({ name }) => colors_1.default(name)};

	.key {
		font-weight: bold;
	}
`;
const StyledMecanismName = styled_components_1.default.button `
	background-color: ${({ name }) => colors_1.default(name)};
	font-size: inherit;
	font-weight: inherit;
	font-family: inherit;
	padding: 0.4rem 0.6rem;
	color: white;
	transition: hover 0.2s;
	${(props) => props.inline
    ? `
		display: inline-block;
		border-radius: 0.3rem;
		`
    : `
		margin-bottom: 0.8rem;
		display: block;

		margin-top: -1rem;
		margin-left: -1rem;
		border-bottom-right-radius: 0.3rem;
		::first-letter {
			text-transform: capitalize;
		}
	`}
	:hover {
		opacity: 0.8;
	}
`;
exports.CapitalizeFirstLetter = styled_components_1.default.div `
	font-weight: bold;
	:first-letter {
		text-transform: capitalize;
	}
`;
// Un élément du graphe de calcul qui a une valeur interprétée (à afficher)
function Leaf(node) {
    const engine = react_1.useContext(contexts_1.EngineContext);
    const { dottedName, nodeValue, unit } = node;
    const rule = engine === null || engine === void 0 ? void 0 : engine.getRule(node.dottedName);
    if (!rule) {
        throw new Error('Unknown node');
    }
    const [folded, setFolded] = react_1.useState(true);
    const foldButton = react_1.useContext(exports.UnfoldIsEnabledContext) ? (jsx_runtime_1.jsx(UnfoldButton, Object.assign({ onClick: () => setFolded(!folded), className: "ui__ notice small static simple button" }, { children: folded ? 'déplier' : 'replier' }), void 0)) : null;
    if (node.dottedName === node.contextDottedName + ' . ' + node.name &&
        !node.name.includes(' . ') &&
        rule.virtualRule) {
        return jsx_runtime_1.jsx(Explanation_1.default, { node: engine === null || engine === void 0 ? void 0 : engine.evaluate(rule) }, void 0);
    }
    return (jsx_runtime_1.jsxs("div", Object.assign({ style: { display: 'inline' } }, { children: [jsx_runtime_1.jsxs("span", { children: [jsx_runtime_1.jsx(RuleLink_1.RuleLinkWithContext, Object.assign({ dottedName: dottedName }, { children: jsx_runtime_1.jsx("span", Object.assign({ className: "name" }, { children: rule.rawNode.acronyme ? (jsx_runtime_1.jsx("abbr", Object.assign({ title: rule.title }, { children: rule.rawNode.acronyme }), void 0)) : (rule.title) }), void 0) }), void 0), foldButton, nodeValue !== null && unit && (jsx_runtime_1.jsx(exports.NodeValuePointer, { data: nodeValue, unit: unit }, void 0))] }, void 0), ' ', !folded && (jsx_runtime_1.jsx("div", Object.assign({ style: {
                    width: '100%',
                } }, { children: jsx_runtime_1.jsx(exports.UnfoldIsEnabledContext.Provider, Object.assign({ value: false }, { children: jsx_runtime_1.jsx(Explanation_1.default, { node: engine === null || engine === void 0 ? void 0 : engine.evaluate(rule) }, void 0) }), void 0) }), void 0))] }), void 0));
}
exports.Leaf = Leaf;
exports.UnfoldIsEnabledContext = react_1.createContext(false);
const UnfoldButton = styled_components_1.default.button `
	text-transform: none !important;
	flex: 1 !important;
	margin-left: 0.4rem !important;
	text-align: left !important;
`;
